import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import cloneDeep from 'lodash/cloneDeep';
import queryString from 'query-string';

import { getUser, saveUser } from '../services/user.service';
import UserModel from '../models/user.model';
import { CustomSelect, Input } from '../../common/components';
import Breadcrumb from '../../common/components/breadcrumb.component';

const options = [
  { value: 0, label: 'Administrator' },
  { value: 1, label: 'Pracownik techniczny' },
  { value: 2, label: 'Klient' },
];

const initialState = {
  name: '',
  email: '',
  active: false,
  role: options[2],
};

const getOptionLabel = (item) => item.label;

const getOptionValue = (item) => item.value;

class User extends PureComponent {
  state = cloneDeep(initialState);

  async componentDidMount() {
    const { match: { params } } = this.props;
    let user = {};
    this.queryValues = queryString.parse(this.props.location.search);

    if (params.id) {
      user = await getUser(params.id);
      user.role = options.find((option) => option.value === user.role);
    }

    this.setState(user);
  }

  onInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  onRoleChange = (_, role) => {
    this.setState({
      role,
    });
  }

  onFormSave = async () => {
    const { history } = this.props;
    const { role } = this.state;
    const data = { ...this.state, role: role.value, ...this.queryValues };

    const userModel = new UserModel(data);
    const errors = userModel.validate();

    if (!errors) {
      try {
        await saveUser(data);
        history.replace('/users');
      } catch (err) {
        console.log(err);
      }
    }

    this.setState({ errors });
  }

  render() {
    const {
      name,
      email,
      role,
      active,
      errors,
    } = this.state;

    const {
      match: { params },
      user: { role: userRole },
    } = this.props;

    const title = params.id ? 'Edycja użytkownika' : 'Dodawanie nowego użytkownika';

    return (
      <>
        <Breadcrumb title={title} />
        <div className="content">
          <div className="card">
            <div className="card-header">
              Dane użytkownika
            </div>
            <div className="card-body card-block">
              <div className="form-horizontal">
                <Input
                  label="Imię i nazwisko"
                  id="name"
                  value={name}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  label="Email"
                  id="email"
                  value={email}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                {userRole === 0 && (
                  <div className="row form-group">
                    <div className="col col-md-3">
                      <label className="form-control-label">Rola</label>
                    </div>
                    <div className="col-12 col-md-9">
                      <CustomSelect
                        data={{ id: 'role' }}
                        value={role}
                        onChange={this.onRoleChange}
                        options={options}
                        getOptionLabel={getOptionLabel}
                        getOptionValue={getOptionValue}
                        errors={errors}
                      />
                    </div>
                  </div>
                )}

                {(params.id) && (
                  <Input
                    label="Aktywna"
                    id="active"
                    value={active}
                    onChange={this.onInputChange}
                    type="checkbox"
                    errors={errors}
                    horizontal
                  />
                )}
              </div>
            </div>
            <div className="d-flex justify-content-end p-4">
              <button
                onClick={this.onFormSave}
                className="btn btn-primary btn-sm"
                type="button"
              >
                Zapisz
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

User.defaultProps = {};

User.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  user: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(User);
